import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

if (document.getElementById('vue-communs')) {
  new Vue({
    el: '#vue-communs',
    data() {
      return {
        apiUrl: `${location.origin}/wp-json/wp/v2/resources/`,
        loading: false,
        communs: [],
        page: 0,
        totalPages: null
      }
    },
    computed: {
      firstPost() {
        const communs = [ ...this.communs ]
        return communs.shift()
      },
      shiftCommuns() {
        const communs = [ ...this.communs ]
        communs.shift()
        return communs
      }
    },
    mounted() {
        moment.locale(document.getElementById('vue-communs').dataset.lang);
        this.getCommuns()
    },
    filters: {
      date(value) {
        return moment(value).format('D MMMM YYYY')
      }
    },
    methods: {
        getCommuns() {
        this.loading = true
        axios.get(this.apiUrl, { params: {
            per_page: 8,
            offset: this.page * 8,
            lang: document.getElementById('vue-communs').dataset.lang
            }
        })
        .then(response => {
            this.communs = this.communs.concat(response.data);
            this.loading = false;
            this.totalPages = response.headers['x-wp-totalpages']
        })
        },
        getMore() {
          this.page++;
          this.getCommuns()
        },
        getCommunThumbnail(commun, size) {
          return commun.acf.image.sizes[size]
        },
        isDownlable(commun) {
          console.log(commun.acf.file ? true : false)
          return commun.acf.file ? true : false
        },
        openFile(url) {
            window.open(url, '_blank');
        }
      // Contact Form
      //   onSuccess(event) {
      //     eventHub.$emit('toast:info', {
      //       title: 'C\'est envoyé !',
      //       content: 'OPEO a bien reçu votre demande.',
      //       autoleave: true
      //     })
      //     if (event['inscription_a_la_newsletter'] && event['email']) {
      //       this.registerUserToNewsletter(event)
      //     }
      //   },
      //   registerUserToNewsletter(event) {
      //     const data = new FormData
      //     data.append('email', event.email)
      //     axios.post(`${this.apiUrl}/mailchimp/v1/register`, data, { headers: this.headers })
      //   },
      //   onError() {
      //     eventHub.$emit('toast:danger', {
      //       title: 'Oups !',
      //       content: 'Désolé. Certains champs semblent manquants ou mal renseignés.',
      //       autoleave: true
      //     })
      //   },
      //   onRecaptchaError() {
      //     eventHub.$emit('toast:danger', {
      //       title: 'Oups !',
      //       content: 'Le reCaptcha doit être validé pour soumettre le formulaire.',
      //       autoleave: true
      //     })
      //   },
      //   // Newsletter Fomr
      //   register() {
      //     if (this.allowRegister) {
      //       this.loading = true
      //       const data = new FormData
      //       data.append('email', this.email)
      //       axios
      //         .post(`${this.apiUrl}/mailchimp/v1/register`, data, { headers: this.headers })
      //         .then(() => {
      //           this.email = ''
      //           this.allowRegister = false
      //           eventHub.$emit('toast:info', {
      //             title: 'Bienvenue !',
      //             content: 'OPEO vous remercie pour votre inscription.',
      //             autoleave: true
      //           })
      //         })
      //         .catch(error => {
      //           const response = error.response
      //           if (response.status == 400) {
      //             eventHub.$emit('toast:warning', {
      //               title: 'Oups !',
      //               content: response.data.data ? 'Vous semblez déjà inscrit(e) sur notre liste de diffusion.' : 'Le format d\'email semble erroné.',
      //               autoleave: true
      //             })
      //           } else {
      //             eventHub.$emit('toast:danger', {
      //               title: 'Oups !',
      //               content: 'Nous n\'avons pas pu vous inscrire sur notre liste, merci de réessayer ultérieurement',
      //               autoleave: true
      //             })
      //           }
      //         })
      //         .then(() => {
      //           this.loading = false
      //         })
      //     }
      // }

      // Members

    },
    // directives: {
    //   scrollTo,
    //   showOnScroll
    // },
  })
}